<div *ngIf="isResponseLoading">
  <mat-card class="drawer-card tab-content-container">
    <app-common-loader></app-common-loader>
  </mat-card>
</div>
<div *ngIf="!isResponseLoading && this.asset?.name" class="d-flex justify-content-start flex-column">
  <mat-card class="mat-focus-indicator mb-3 mat-elevation-z0 w-100 ng-star-inserted px-2">
    <div [ngClass]="displayAtTop ? '' : 'custom-scroller'">
      <div *ngIf="!hideButtons && displayAtTop" class="w-100">
        <mat-card class="mat-focus-indicator mat-elevation-z0 px-0">
          <div class="d-flex align-items-center flex-row justify-content-between asset-action-wrapper">
            <p class="font-14 font-semibold mb-2 ng-star-inserted ps-4">Asset</p>
            <app-action-buttons *ngIf="displayAtTop" [isShowSendToTenant]="isShowSendToTenant"
              (buttonClicked)="onActionButtonClick($event)" [asset]="asset"></app-action-buttons>
          </div>
        </mat-card>
      </div>
      <div class="d-flex align-items-center justify-content-start w-100 mt-3 px-4">
        <span class="common-tag yellow" *ngIf="showSendToTenantTag">Sent to Tenant</span>
        <span class="common-tag yellow" *ngIf="showNeedToBeApprovedTag">Need to be Approved</span>
        <span class="common-tag yellow" *ngIf="showNeedToBeApprovedTag && asset?.isOnceSendToTenantAsset && asset?.status == 4">Tenant Completed</span>
        <span class="common-tag yellow" *ngIf="showDuplicatedTag">Duplicated</span>
        <span class="common-tag" *ngIf="asset?.areaLevel">{{asset?.areaLevel}}</span>
      </div>
      <mat-card *ngIf="asset?.isAiGenarated" class="mat-elevation-z0 warning-card mb-4 font-12">
        <mat-icon class="float-start me-3">warning</mat-icon>
        <span>Following details are AI - generated content, please review
          carefully.</span>
      </mat-card>

      <mat-card class="mat-card mat-focus-indicator mat-elevation-z0 px-4">
        <div class="row mb-2 d-flex w-100">
          <div class="col-6 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Asset name</h5>
              <p>{{ asset?.name }}</p>
            </div>
          </div>

          <div class="col-6 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Manufacturer</h5>
              <p>{{ asset?.make }}</p>
            </div>
          </div>

          <div class="col-6 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Model</h5>
              <p>{{ asset?.model }}</p>
            </div>
          </div>
          <div class="col-6 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Barcode</h5>
              <p>{{ asset?.barcode }}</p>
            </div>
          </div>
          <div class="col-6 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Date of purchase</h5>
              <p>{{ asset?.dateOfPurchase | date : "dd/MM/yyyy" }}</p>
            </div>
          </div>


          <div class="col-6 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Cost($)</h5>
              <p>{{asset?.cost | number:'1.2-2'}}</p>
            </div>
          </div>

          <div class="col-6 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Useful life period (Years)</h5>
              <p>{{ asset?.usefulLife }} years</p>
            </div>
          </div>
          <div class="col-6 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Maintenance cycle</h5>
              <p>{{ maintenanceCycleLabel(asset?.maintenanceCycle) }}</p>
            </div>
          </div>
        </div>
        <div class="mb-2 d-flex w-100">
          <div class="w-100 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Description</h5>
              <p>{{ asset?.description }}</p>
            </div>
          </div>
        </div>
        <div class="mb-2 d-flex w-100">
          <div class="w-100 d-inline-block brief-section my-2">
            <div class="details float-start">
              <h5>Note</h5>
              <p>{{ asset?.note }}</p>
            </div>
          </div>
        </div>
        <div class="mb-2 d-inline-block w-100">
          <div class="w-100 d-flex brief-section my-2">
            <div class="details float-start">
              <h5>Attachments</h5>
              <app-file-list-viewer [files]="asset?.attachments" [isReadOnly]="true"></app-file-list-viewer>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </mat-card>
  <div *ngIf="!hideButtons" class="w-100 d-flex justify-content-end align-items-center mt-3">
    <app-action-buttons *ngIf="!displayAtTop" [asset]="asset" [isShowSendToTenant]="isShowSendToTenant" [assetStatus]="assetStatus" 
      (buttonClicked)="onActionButtonClick($event)"></app-action-buttons>
  </div>
</div>

<mat-sidenav-container class="example-container" [hasBackdrop]="true">
  <mat-sidenav [fixedInViewport]="true" #drawer mode="over" class="lg" position="end" [disableClose]="true"
    [opened]="openAssetEditDrawer">
    <app-edit-asset *ngIf="openAssetEditDrawer" [assetDetails]="asset"
      (dismissEditAssetDrawer)="closeEditAssetDrawer($event)"></app-edit-asset>
  </mat-sidenav>
</mat-sidenav-container>